<template>
  <div>
    <v-row>
      <v-col cols="12" class="pb-0">
        <span class="subtitle-bold-font">Mensagem de resposta</span>
        <mf-textarea-emoji
          v-model="localFlowConfiguration.message"
          class="textarea"
          outlined
          no-resize
          rows="4"
          hide-counter
          :max-length="0"
          :error-messages="messageError"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { simpleResponseValidation } from '@/modules/campanhas/whatsapp/validations/flows.js'
import isEqual from 'lodash/isEqual'
import cloneDeep from 'lodash/cloneDeep'

export default {
  props: {
    flowConfiguration: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    localFlowConfiguration: {},
  }),
  computed: {
    messageError() {
      if (this.$v.localFlowConfiguration?.$error) {
        if (!this.$v.localFlowConfiguration?.message?.required) return 'Escreva uma mensagem para essa resposta simples.'
        if (!this.$v.localFlowConfiguration?.message?.minLength) return 'A mensagem possui menos de 2 caracteres.'
        if (!this.$v.localFlowConfiguration?.message?.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      }
      return ''
    },
  },
  watch: {
    flowConfiguration: {
      deep: true,
      handler(val) {
        if (!isEqual(val, this.localFlowConfiguration)) {
          this.localFlowConfiguration = cloneDeep(val)
        }
      },
    },

    localFlowConfiguration: {
      deep: true,
      handler(val) {
        if (!isEqual(val, this.flowConfiguration)) {
          this.$emit('input', val)
        }
      },
    },
  },

  created() {
    this.localFlowConfiguration = cloneDeep(this.flowConfiguration)
  },
  methods: {
    computeMessages() {
      return [
        {
          fromBot: true,
          text: this.localFlowConfiguration.message,
        },
      ]
    },
    validate() {
      this.$v.$reset()
      this.$v.$touch()
      return this.$v.$error
    },
  },
  validations() {
    return {
      localFlowConfiguration: simpleResponseValidation(),
    }
  },
}
</script>
